import {reactionsHttpRepository} from '../../repositories/reactions-http-repository';
import {reactionsMemoryRepository} from '../../repositories/reactions-memory-repository';

export const readReactions = articleId => reactionsHttpRepository.getCommonReactions(articleId)
  .then(response => reactionsMemoryRepository.setReactions(articleId, response.reactions))
  .catch(console.error);

